import React from "react";

import { makeStyles, Typography } from "@material-ui/core";
import { MdCheckCircle } from "react-icons/md";

import HStack from "modules/core/components/HStack";

const useStyles = makeStyles(theme => ({
  list: {
    display: "flex",
    flexDirection: "column",
    gap: 5
  },

  icon: {
    color: theme.palette.success.main,
    lineHeight: 0
  }
}));

const items = [
  "Research, ideation and testing all centralised.",
  "Detailed program statistics & insights.",
  "Team collaboration & task management.",
  "Roadmaps to visualise your testing pipeline.",
  "Access to your team's complete historic data."
];

const TeamUsageStep = () => {
  const classes = useStyles();

  return (
    <div>
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginBottom: 15 }}
      >
        Your team has been usingEfestra to centralise and document the whole
        experimentation process.
      </Typography>

      <div className={classes.list}>
        {items.map((item, index) => (
          <HStack gap={4} key={index}>
            <span className={classes.icon}>
              <MdCheckCircle size={18} />
            </span>

            <Typography variant="body2" color="textSecondary">
              {item}
            </Typography>
          </HStack>
        ))}
      </div>
    </div>
  );
};

export default React.memo(TeamUsageStep);
